// src/components/AppLayout.jsx
import React from "react";
import NavBar from "./NavBar";

export default function AppLayout({ children, isAuthenticated, userRole, handleLogout }) {
    return (
        <div className="relative min-h-screen bg-zinc-50 text-zinc-950 dark:bg-zinc-950 dark:text-zinc-50">
            {/* Ambient brand glow backdrop */}
            <div
                aria-hidden="true"
                className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
            >
                <div className="absolute -top-40 left-1/2 h-[480px] w-[820px] -translate-x-1/2 rounded-full bg-brand-gradient-soft blur-3xl" />
                <div className="absolute bottom-0 right-0 h-[360px] w-[360px] translate-x-1/3 translate-y-1/3 rounded-full bg-brand-500/5 blur-3xl dark:bg-brand-500/10" />
            </div>

            <NavBar
                isAuthenticated={isAuthenticated}
                userRole={userRole}
                handleLogout={handleLogout}
            />
            <main className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-6">{children}</main>

            <footer className="mt-16 border-t border-zinc-200/70 dark:border-zinc-800/70">
                <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-8 text-sm text-zinc-500 sm:flex-row sm:px-6 dark:text-zinc-400">
                    <div className="flex items-center gap-2">
                        <span className="grid h-6 w-6 place-items-center rounded-md bg-brand-gradient text-[10px] font-bold text-white">
                            FF
                        </span>
                        <span className="font-medium text-zinc-700 dark:text-zinc-300">FormForge</span>
                    </div>
                    <p>Create templates. Collect submissions. Analyze responses.</p>
                </div>
            </footer>
        </div>
    );
}
